import { atom } from "recoil";

const winScreenState = atom<boolean>({
  key: "winScreenState",
  default: false,
});

export default winScreenState;
